import { memo, useContext, useEffect, useRef, useState } from 'react'
import { Page } from '@/styles'
import { Modal } from 'antd';
import { Text } from '@pancakeswap/uikit'

import MarketBotLeft from './MarketBotLeft'
import MarketBotRight from './MarketBotRight'
import { PageLeft, PageRight } from './style'
import { AppContext } from '@/context';
import Footer from './MarketBotLeft/Footer';
import { useSelector } from 'react-redux';
import { isAdvanced, mainConfig } from '@/store';

function App() {
  const { Lang } = useContext(AppContext)

  const [isModalOpen, setIsModalOpen] = useState(true);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const leftRef = useRef<HTMLDivElement | null>(null)
  const rightRef = useRef<HTMLDivElement | null>(null)
  const _mainConfig = useSelector(mainConfig)
  const _isAdvanced = useSelector(isAdvanced)

 const syncHeight = () => {
  if (leftRef.current && rightRef.current) {
    const leftHeight = leftRef.current.offsetHeight
    rightRef.current.style.height = 'auto' // 先重置
    rightRef.current.style.height = `${leftHeight}px`
  }
}

  useEffect(() => {
  // 每次内容变化后同步一次
  const timeout = setTimeout(() => syncHeight(), 0)
  return () => clearTimeout(timeout)
}, [_mainConfig.mode, _isAdvanced])


  return (
    <>
      <Page>
        {/* <>

          <Modal title="警告" open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
            <p>币安内盘市值机器人用防夹节点可以批量卖（滑点可以设置稍微高点），但是不要批量买（且滑点要设置低点）

            </p>
            <p style={{ color: "red" }}>使用市值机器人，请重新生成新的钱包地址</p>
            <p style={{ color: "red" }}>请大家养成随手归集的好习惯</p>
            <Text marginTop='1rem' color='red' >{Lang.a8}</Text>
            <Text marginTop='1rem' color='red' >{Lang.a9}</Text>
            <Text marginTop='1rem' color='red' >{Lang.a10}</Text>
            <Text marginTop='1rem' color='red' >4:{Lang.c12}</Text>
          </Modal>
        </> */}

        <PageLeft ref={leftRef} style={styles.left}>
          <MarketBotLeft />
        </PageLeft>
        <PageRight ref={rightRef} style={styles.right}>
          <MarketBotRight />
        </PageRight>
      </Page>
      <Footer />
    </>
  )
}

export default memo(App)

const styles: Record<string, React.CSSProperties> = {
  container: {
    display: "flex",
    alignItems: "flex-start", // 让顶部对齐，不被拉伸
  },
  left: {
    flex: 1,
  },
  right: {
    flex: 1,
    overflowY: "auto", // ✅ 内容多时滚动
  },
}
